var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"large-btn",class:("" + (this.type))},_vm.$listeners),[_c('p',{staticClass:"p"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }